import { useMemo } from 'react'
import Header from './Header'
import Preferences from '../preferences'
import type { VFC } from 'react'
import type { CommonModuleProps } from '../common/types'

type UserPreferencesProps = CommonModuleProps & {
  theme: string
}

const UserPreferences: VFC<UserPreferencesProps> = ({ theme }) => {
  const header = useMemo(() => <Header title='User Preferences' />, [])
  return (
    <div className='cm-w-full cm-h-full cm-flex cm-flex-col'>
      {header}
      <div className='cm-relative cm-flex-1 cm-bg-white dark:cm-bg-gray-1050'>
        <Preferences theme={theme}/>
      </div>
    </div>
  )
}
export default UserPreferences
